(function () {
  if (window.__platinSubcatNavV5Loaded) return;
  window.__platinSubcatNavV5Loaded = true;

  function getIconAssets() {
    return window.PlatinCategoryIconAssets || {};
  }

  function getIconRules() {
    return Array.isArray(window.PlatinCategoryIconRules) ? window.PlatinCategoryIconRules : [];
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[״"]/g, '"')
      .replace(/[׳']/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanTitle(value) {
    return normalizeText(value)
      .replace(/\(\d+\)/g, '')
      .replace(/loading collection image/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findIconByTitle(title) {
    var iconAssets = getIconAssets();
    var iconRules = getIconRules();
    var normalizedTitle = cleanTitle(title);

    if (!normalizedTitle) return null;

    for (var i = 0; i < iconRules.length; i++) {
      var exactKeywords = iconRules[i].exact || [];

      for (var j = 0; j < exactKeywords.length; j++) {
        if (normalizedTitle === normalizeText(exactKeywords[j])) {
          return {
            src: iconAssets[iconRules[i].icon],
            key: iconRules[i].icon
          };
        }
      }
    }

    for (var r = 0; r < iconRules.length; r++) {
      var keywords = iconRules[r].keywords || [];

      for (var k = 0; k < keywords.length; k++) {
        if (normalizedTitle.indexOf(normalizeText(keywords[k])) !== -1) {
          return {
            src: iconAssets[iconRules[r].icon],
            key: iconRules[r].icon
          };
        }
      }
    }

    return null;
  }

  function createOrUpdateIcon(link, iconSrc, title) {
    if (!link || !iconSrc) return;

    var imageWrapper = link.querySelector('.subcat-grid-link__image');

    if (!imageWrapper) {
      imageWrapper = document.createElement('span');
      imageWrapper.className = 'subcat-grid-link__image';
      link.insertBefore(imageWrapper, link.firstChild);
    }

    var imageCentered = imageWrapper.querySelector('.subcat-grid-link__image-centered');

    if (!imageCentered) {
      imageWrapper.innerHTML = '';
      imageCentered = document.createElement('span');
      imageCentered.className = 'subcat-grid-link__image-centered';
      imageWrapper.appendChild(imageCentered);
    }

    var img = imageCentered.querySelector('.subcat-grid-link__image-img');

    if (!img) {
      imageCentered.innerHTML = '';
      img = document.createElement('img');
      img.className = 'subcat-grid-link__image-img';
      imageCentered.appendChild(img);
    }

    if (img.getAttribute('src') !== iconSrc) {
      img.src = iconSrc;
    }

    img.alt = title ? 'אייקון ' + String(title).trim() : '';
    img.loading = 'eager';
    img.decoding = 'async';

    if ('fetchPriority' in img) {
      img.fetchPriority = 'high';
    }

    link.classList.add('has-smart-category-icon');
  }

  function applySmartIcons(bar) {
    if (!bar) return;

    var links = bar.querySelectorAll('.subcat-grid-link');

    links.forEach(function (link) {
      var titleEl = link.querySelector('.subcat-grid-link__title');
      var title = titleEl ? titleEl.textContent : link.textContent;
      var iconMatch = findIconByTitle(title);

      if (!iconMatch || !iconMatch.src) return;

      createOrUpdateIcon(link, iconMatch.src, title);
      link.dataset.platinIcon = iconMatch.key;
    });
  }

  function enhanceBar(bar) {
    if (!bar) return;

    if (bar.classList.contains('subcatzero')) {
      bar.classList.add('platin-subcat-ready');
      return;
    }

    var wrapper = bar.closest('.platin-subcat-slider');

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'platin-subcat-slider';

      var rightArrow = document.createElement('span');
      rightArrow.className = 'platin-subcat-arrow platin-subcat-arrow--right';
      rightArrow.setAttribute('role', 'button');
      rightArrow.setAttribute('tabindex', '0');
      rightArrow.setAttribute('aria-label', 'גלילה ימינה');
      rightArrow.innerHTML = '‹';

      var leftArrow = document.createElement('span');
      leftArrow.className = 'platin-subcat-arrow platin-subcat-arrow--left';
      leftArrow.setAttribute('role', 'button');
      leftArrow.setAttribute('tabindex', '0');
      leftArrow.setAttribute('aria-label', 'גלילה שמאלה');
      leftArrow.innerHTML = '›';

      bar.parentNode.insertBefore(wrapper, bar);
      wrapper.appendChild(rightArrow);
      wrapper.appendChild(bar);
      wrapper.appendChild(leftArrow);

      function scrollByAmount(amount) {
        bar.scrollBy({
          left: amount,
          behavior: 'smooth'
        });
      }

      rightArrow.addEventListener('click', function () {
        scrollByAmount(280);
      });

      leftArrow.addEventListener('click', function () {
        scrollByAmount(-280);
      });

      [rightArrow, leftArrow].forEach(function (arrow) {
        arrow.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            scrollByAmount(arrow === rightArrow ? 280 : -280);
          }
        });
      });
    }

    function updateOverflowState() {
      var hasOverflow = bar.scrollWidth > bar.clientWidth + 8;
      wrapper.classList.toggle('has-overflow', hasOverflow);
    }

    function makeReady() {
      applySmartIcons(bar);
      updateOverflowState();

      requestAnimationFrame(function () {
        bar.classList.add('platin-subcat-ready');
      });
    }

    makeReady();

    if (bar.dataset.platinObserverAttached !== 'true') {
      bar.dataset.platinObserverAttached = 'true';

      var observerTimer = null;

      var observer = new MutationObserver(function () {
        clearTimeout(observerTimer);

        observerTimer = setTimeout(function () {
          makeReady();
        }, 60);
      });

      observer.observe(bar, {
        childList: true,
        subtree: true
      });
    }

    bar.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;

      img.addEventListener('load', updateOverflowState);
      img.addEventListener('error', updateOverflowState);
    });

    window.addEventListener('resize', updateOverflowState);

    setTimeout(makeReady, 150);
    setTimeout(makeReady, 400);
    setTimeout(makeReady, 900);
    setTimeout(makeReady, 1500);

    setTimeout(function () {
      bar.classList.add('platin-subcat-ready');
    }, 1800);
  }

  function processBars() {
    var bars = document.querySelectorAll('#uncomplicated-icons');

    if (!bars.length) return false;

    bars.forEach(enhanceBar);
    return true;
  }

  function bootWithRetries() {
  var attempts = 0;
  var maxAttempts = 80;

  function tryBoot() {
    attempts++;

    var hasBars = !!document.querySelector('#uncomplicated-icons');
    var hasRules =
      Object.keys(getIconAssets()).length > 0 &&
      getIconRules().length > 0;

    if (hasBars && hasRules) {
      processBars();
      return;
    }

    if (attempts < maxAttempts) {
      setTimeout(tryBoot, 100);
      return;
    }

    document.querySelectorAll('#uncomplicated-icons').forEach(function (bar) {
      bar.classList.add('platin-subcat-ready');
    });
  }

  tryBoot();

  setTimeout(processBars, 500);
  setTimeout(processBars, 1000);
  setTimeout(processBars, 2000);
  setTimeout(processBars, 3500);
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWithRetries);
  } else {
    bootWithRetries();
  }

  window.addEventListener('load', function () {
    processBars();
  });

  var pageObserver = new MutationObserver(function () {
    processBars();
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();